var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3615 14.5315H10.544C10.2838 14.5313 10.0276 14.468 9.79715 14.3471C9.56674 14.2262 9.36905 14.0513 9.22102 13.8373C9.073 13.6233 8.97903 13.3766 8.94717 13.1184C8.91532 12.8601 8.94651 12.598 9.0381 12.3544L11.3911 6.10148L11.5773 5.60427L13.293 1.04346C13.4155 0.710022 13.646 0.427113 13.9478 0.239704C14.2496 0.0522952 14.6054 -0.0288588 14.9586 0.00914267C20.702 0.691525 25.2843 6.03396 25.9657 12.7862C25.9855 13.0084 25.9587 13.2324 25.8869 13.4437C25.8152 13.655 25.7002 13.849 25.5492 14.0132C25.3982 14.1775 25.2146 14.3085 25.0101 14.3977C24.8055 14.487 24.5847 14.5325 24.3615 14.5315Z",
    fill: "#519FD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9078 17.6214C25.1313 23.6575 20.595 28.3922 14.9324 28.9897C14.5858 29.0229 14.2378 28.9434 13.9401 28.7629C13.6424 28.5825 13.411 28.3107 13.2801 27.9881L11.6535 24.0401L11.4488 23.5491L11.1685 22.8697L9.17253 18.0276C9.07029 17.7802 9.03061 17.5114 9.05701 17.245C9.0834 16.9786 9.17505 16.7228 9.32385 16.5003C9.47264 16.2777 9.674 16.0953 9.9101 15.9691C10.1462 15.8429 10.4098 15.7769 10.6775 15.7769H24.2913C24.5232 15.7779 24.7523 15.8282 24.9632 15.9244C25.1742 16.0206 25.3624 16.1605 25.5152 16.3349C25.668 16.5093 25.7821 16.7142 25.8497 16.936C25.9174 17.1578 25.9372 17.3914 25.9078 17.6214Z",
    fill: "#2D5BA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4157 19.9128L16.9171 18.6401L16.8363 19.1834L25.2479 20.4264L25.4157 19.9128Z",
    fill: "#1A3E75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2476 20.426L16.8922 19.1902L16.8114 19.7324L25.0552 20.9447L25.2476 20.426Z",
    fill: "#1A3E75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9265 10.3756L25.1407 9.0364L24.9565 8.50952L16.8385 9.83336L16.9265 10.3756Z",
    fill: "#1A3E75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7512 9.85378L24.9562 8.50947L24.7464 7.99487L16.6632 9.31258L16.7512 9.85378Z",
    fill: "#1A3E75"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6434 19.2291L16.4652 18.6091V10.3673L20.6434 9.69824V19.2291Z",
    fill: "#3778BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4651 18.6093L12.288 17.9945V11.0469L16.4651 10.3594V18.6093Z",
    fill: "#17428D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0872 20.1821L24.8221 19.8455V9.05014L27.0616 8.68491C27.3003 8.64593 27.5447 8.65928 27.7777 8.72404C28.0108 8.7888 28.227 8.90343 28.4114 9.05998C28.5957 9.21653 28.7439 9.41128 28.8456 9.63074C28.9473 9.8502 29.0001 10.0891 29.0003 10.331V18.5288C29.0007 18.7688 28.9493 19.0061 28.8496 19.2244C28.75 19.4428 28.6043 19.6371 28.4227 19.794C28.2411 19.9509 28.0278 20.0668 27.7973 20.1338C27.5669 20.2008 27.3246 20.2173 27.0872 20.1821Z",
    fill: "#63B9E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8225 19.8482L20.6433 19.2293V9.69843L24.8225 9.0498V19.8482Z",
    fill: "#509FD8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2164 22.9859L11.3893 6.10535L11.5755 5.62451H17.3282C17.5042 5.62478 17.6729 5.69482 17.7974 5.81928C17.9219 5.94374 17.9919 6.11247 17.9922 6.28848V23.2713C17.9924 23.3586 17.9755 23.4451 17.9422 23.5259C17.9089 23.6066 17.8601 23.68 17.7984 23.7418C17.7367 23.8036 17.6634 23.8526 17.5827 23.8859C17.502 23.9193 17.4155 23.9364 17.3282 23.9363H11.6083L11.2164 22.9879",
    fill: "#1A3E75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3918 6.75917V22.8049C17.3884 22.9777 17.3165 23.1422 17.1921 23.2622C17.0677 23.3822 16.9007 23.4481 16.7279 23.4453H11.408L11.2177 22.986L3.41682 22.7701C3.31935 22.544 3.26955 22.3002 3.27052 22.054L6.83896 7.29321C6.84678 6.89116 6.99726 6.50498 7.26353 6.20365C7.27172 6.19137 7.25535 6.12896 7.26353 6.11873H16.7299C16.9026 6.116 17.0693 6.18191 17.1934 6.30199C17.3175 6.42207 17.3889 6.5865 17.3918 6.75917Z",
    fill: "#1A3E75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2033 6.10742H0.675221C0.302307 6.10742 0 6.40973 0 6.78264V22.3107C0 22.6836 0.302307 22.9859 0.675221 22.9859H16.2033C16.5762 22.9859 16.8785 22.6836 16.8785 22.3107V6.78264C16.8785 6.40973 16.5762 6.10742 16.2033 6.10742Z",
    fill: "#17428D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5248 9.17749V11.3668H7.86377V19.0685C7.86377 19.2815 7.82176 19.4925 7.74012 19.6893C7.65849 19.8861 7.53885 20.0649 7.38805 20.2154C7.23724 20.3659 7.05823 20.4853 6.86127 20.5665C6.6643 20.6478 6.45324 20.6894 6.24017 20.689H5.26929V9.17749H12.5248Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3113 14.0583H8.71582V16.6539H11.3113V14.0583Z",
    fill: "#EBAE06"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlex);
export default __webpack_public_path__ + "static/media/Flex.17e1372819d1ec11ae2cf4cb2254fea9.svg";
export { ForwardRef as ReactComponent };